import axios, { buildURL } from '../api-axios'
import encode from 'strict-uri-encode'

export default {
  fetchInstallations(query = {}) {
    return axios.get(buildURL('/installations', query))
  },
  fetchInstallationDetails(id) {
    return axios.get(`/installations/${encode(id)}`)
  }
}
